'use client';

//* Hooks
import useDynamicManifest from '@/hooks/useDynamicManifest';

export default function ManifestManager() {
	useDynamicManifest();
	return null;
}
